<div *ngIf="!(employmentStatuses$ | async)">Loading Employment Status List...</div>

<select *ngIf="employmentStatuses$ | async" [(ngModel)]="model.employmentStatus" [compareWith]="byId"
        [required]="required"
        class="form-control" name="employmentStatus">
  <option *ngFor="let singleEmploymentStatus of employmentStatuses$ | async"
          [ngValue]="singleEmploymentStatus">{{ singleEmploymentStatus.name }}</option>
</select>
